import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgUserGroupSolidCircle = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	id: "Layer_1",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	x: "0px",
	y: "0px",
	viewBox: "0 0 48 48",
	style: { enableBackground: "new 0 0 48 48" },
	xmlSpace: "preserve",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("style", {
			type: "text/css",
			children: "\n	.st0{fill:#FFFFFF;}\n"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 24,
			cy: 24,
			r: 24
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "st0",
			d: "M19.5,24c3.3,0,6-2.7,6-6s-2.7-6-6-6s-6,2.7-6,6S16.2,24,19.5,24z M21.9,26.2h-4.8c-4.5,0-8.1,3.6-8.1,8.1 c0,0.9,0.7,1.6,1.6,1.6h17.7c0.9,0,1.6-0.7,1.6-1.6C30,29.9,26.4,26.2,21.9,26.2z M31.5,27H28c2.2,1.8,3.5,4.4,3.5,7.4 c0,0.6-0.2,1.2-0.5,1.6h6.5c0.8,0,1.5-0.7,1.5-1.5C39,30.4,35.6,27,31.5,27z M29.2,24c2.9,0,5.2-2.3,5.2-5.2s-2.3-5.2-5.2-5.2 c-1.2,0-2.3,0.4-3.1,1.1c0.5,1,0.9,2.2,0.9,3.4c0,1.7-0.6,3.2-1.5,4.4C26.5,23.4,27.8,24,29.2,24z"
		})
	]
});
const ForwardRef = forwardRef(SvgUserGroupSolidCircle);
export default ForwardRef;
